import styled from "styled-components";

export const MemberActionWidgetsStyled = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  &:hover {
    .dropdown_menu_list {
      display: block;
    }
  }
  .logo_user {
    margin-right: 12px;
  }
  .user_name {
    margin-right: 18px;
    color: ${({ theme }) => theme.COLORS.PURPLE_1};
    font-size: ${({ theme }) => theme.FONT.SIZE.S14};
    font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
  }
  .dropdown_menu_list {
    display: none;
    position: absolute;
    top: 100%;
    right: 0;
    min-width: 160px;
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
    padding: 8px 0;
    z-index: 100;

    .dropdown_item {
      padding: 10px 16px;
      display: flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      color: ${({ theme }) => theme.COLORS.BLACK_6};
      font-size: ${({ theme }) => theme.FONT.SIZE.S14};
      font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
      white-space: nowrap;
      &:hover {
        text-decoration: underline;
        color: ${({ theme }) => theme.COLORS.PURPLE_1};
        svg {
          path {
            fill: ${({ theme }) => theme.COLORS.PURPLE_1};
          }
        }
      }
    }
  }
`;
